import React, { FC, useState, useMemo } from "react";
import { Button } from "@chakra-ui/react";
import { WindowData, restrictedModalItems } from "../utils";
import WebsiteOrSignatureListModal from "js/components/WebsiteOrSignatureListModal";
import { IGetSignatureDbReturn } from "@/stores/signatureStore_I";
import { User } from "@/js/utils/userUtils";

type RestrictedAppsModalProps = {
	screenshotData: WindowData;
	isMonitorMode: boolean;
	isClassActive: boolean;
	signatures: IGetSignatureDbReturn;
	student: User;
	forceCloseTab: (tabId: string, force: boolean) => void;
	canCloseTab: boolean;
};

export const RestrictedAppsModal: FC<RestrictedAppsModalProps> = ({
	screenshotData,
	isMonitorMode,
	isClassActive,
	signatures,
	student,
	...props
}) => {
	const [open, setOpen] = useState(false);
	const restrictedItems = useMemo(() => restrictedModalItems(screenshotData), [screenshotData]);

	const openRestrictedModal = (): void => {
		setOpen(true);
	};

	const closeRestrictedAppsModal = () => {
		setOpen(false);
	};

	return (
		<>
			<Button
				data-testid="button-restricted-apps-modal"
				backgroundColor={"transparent"}
				textDecoration={"underline"}
				textColor={"#094C99"}
				display={"flex"}
				paddingLeft={"0"}
				paddingY={"2"}
				fontWeight={"light"}
				onClick={() => openRestrictedModal()}
			>
				View restricted website/app
			</Button>
			<WebsiteOrSignatureListModal
				title="Restricted websites and applications"
				open={open}
				items={restrictedItems}
				signatureDb={signatures}
				user={student}
				onClose={closeRestrictedAppsModal}
				forceCloseTab={props.forceCloseTab}
				canCloseTab={props.canCloseTab}
				classIsActive={isClassActive}
				isMonitorMode={isMonitorMode}
				isRestricted={true}
			/>
		</>
	);
};
